import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Search } from 'lucide-react';

export const IrsLineDialog = ({ open, onClose, selectedIrsLine }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>IRS Tax Line Item</DialogTitle>
        <DialogDescription>Information about this Schedule C line item</DialogDescription>
      </DialogHeader>
      {selectedIrsLine && (
        <div className="space-y-4">
          <div className="p-4 bg-primary/10 rounded-lg">
            <h3 className="font-bold text-primary">{selectedIrsLine.code}</h3>
            <p className="text-lg font-medium mt-1">{selectedIrsLine.name}</p>
          </div>
          <p className="text-muted-foreground">{selectedIrsLine.description}</p>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => window.open('https://www.irs.gov/forms-pubs/about-schedule-c-form-1040', '_blank')}
            data-testid="irs-search-btn"
          >
            <Search className="w-4 h-4 mr-2" />Search IRS.gov
          </Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
